module.exports = __webpack_public_path__ + "e977f5debfc4dc6679a3417fbaa818ba.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/pressSpace.png
// module id = 1bex
// module chunks = 0